import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from '../common';
import { Profile } from './models';

export const profileApiSlice = createApi({
  reducerPath: 'profile/api',
  baseQuery: axiosBaseQuery({
    baseUrl: 'profile/',
  }),
  endpoints: builder => ({
    getProfile: builder.query<Profile, unknown>({
      query: () => ({
        url: '',
        method: 'GET',
      }),
      transformResponse: (response: IAxiosResponse<Profile>) => response.data,
    }),
  }),
});
